import RoundButton from "features/shared/components/buttons/RoundButton";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import React, { forwardRef } from "react";
import MessageSimplifiedDTO from "features/messages/dto/MessageSimplifiedDTO";
import { MessageStatus } from "features/messages/enums/messageStatus";
import styles from "./messagesimplified.module.scss";
import MessageStatusLabel from '../MessageStatusLabel';
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import roundButtonStyles from 'features/shared/components/buttons/roundbutton.module.scss';
import MessageActionsMenu from 'features/messages/components/MessageActionsMenu';
import { useTranslation } from "react-i18next";

interface Props {
  message: MessageSimplifiedDTO;
  onDetailButtonClick: (messageId: string) => void;
  onMenuItemClick: (messageId: string, status: MessageStatus) => void;
}

const MessageSimplified = ({ message, onDetailButtonClick, onMenuItemClick }: Props) => {
  // translations
  const tCategories = useTranslation("messages\\enums\\messageCategory").t;

  // sub-renders
  const CustomToggle = forwardRef((props: any, ref: any) => (
    <button 
      ref={ref}
      className={`btn btn-sm ${roundButtonStyles.roundBtn}`}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  ));

  // render
  return (
    <div className="row align-items-center no-gutters">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-auto col-sm-3 col-lg-2 order-1 order-sm-0 text-muted">
            <DateFormatter date={message.createdOn!} />
            <small className="d-sm-none mx-2 text-muted">|</small>
          </div>
          <div className="col-sm-6 col-lg-5 text-truncate pr-sm-3 pl-sm-2">
            {message.title}
            <div className="d-none d-sm-block d-lg-none small text-muted">
              {tCategories(message.messageCategory!)}
            </div>
          </div>
          <div className="d-sm-none d-lg-block col col-lg-3 order-1 order-sm-0 text-muted text-truncate pr-sm-3">
            {tCategories(message.messageCategory!)}
          </div>
          <div className="col-sm-3 col-lg-2 order-1 order-sm-0 col-xl-2">
            <MessageStatusLabel statusCode={message.messageStatus!}/>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2">
        <div className="d-flex flex-column flex-sm-row">
            <RoundButton
              onClickHandler={() => onDetailButtonClick(message.messageId!)}
            />
          <div className="mt-2 mt-sm-0 ml-sm-2">
            <Dropdown alignRight className={styles.topbarActionItem}>
              <Dropdown.Toggle
                id={`message-grid-menu-${message.messageId}`}
                as={CustomToggle}
              >
                <FontAwesomeIcon icon="cog" />
              </Dropdown.Toggle>
              <MessageActionsMenu 
                messageId={message.messageId!}
                messageStatus={message.messageStatus!}
                onMenuItemClick={onMenuItemClick}
              />
          </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageSimplified;